import React from 'react';
import styles from './Notes.module.scss';
import { useSelector } from 'react-redux';
import { selectNotes } from '@reducers/data/notes';
import DelayedLoader from '@components/DelayedLoader';

export function NotesViewTitle() {
  const notes = useSelector(selectNotes);

  return (
    <div className={styles.viewHeader}>
      Notes
      <DelayedLoader loading={!notes.updated || notes.isFetching} />
    </div>
  );
}
